export const core = {
  title: 'PRUEBA TÚ CONOCIMIENTO',
  description: 'SELECCIONA EL  ESCUDO CORRECTO',
  options: [
    {
      id: 'españa',
      name: 'ESPAÑA',
      image: '/img/v2/register/spain.webp',
      imageWhite: '/img/v2/register/SpainWhite.webp',
    },
    {
      id: 'realsociedad',
      name: 'REAL SOCIEDAD',
      image: '/img/v2/register/realsociedad.webp',
      imageWhite: '/img/v2/register/realsociedadWhite.webp',
    },
    {
      id: 'marathon',
      name: 'MARATHON',
      image: '/img/v2/register/marathon.webp',
      imageWhite: '/img/v2/register/marathonWhite.webp',
    },
  ],
  gains: 'GENEREMOS GANANCIAS',
  lose: '¡INCORRECTO, VUELVELO A INTENTAR!',
};
